/**
 * When true, OTP login verifies automatically once all digits are entered (after Send OTP).
 * Set to false to require the user to tap Login.
 */
export const ENABLE_AUTO_LOGIN_AFTER_OTP_COMPLETE = false;
